// extracted by mini-css-extract-plugin
module.exports = {"md":"actions-tabbar-item_md_3uOMb","ios":"actions-tabbar-item_ios_v2IMj","link":"actions-tabbar-item_link_3QUI7"};